/**
 * Parse the settled promises and return the values of the fulfilled promises
 */
export function parseSettled<T>(settled: PromiseSettledResult<T>[]): T[] {
    return settled.reduce((acc, curr) => {
        if (curr.status === 'fulfilled') {
            acc.push(curr.value)
        }

        return acc
    }, [] as T[])
}
